import { ThemeInterface } from "@styles/theme";
export const styles = (theme: ThemeInterface) => ({
	root: {
		overflowWrap: "anywhere",
		width: "300px",
	},
});
export default styles;
